import { useServerData } from '@xingternal/hops';

import useLoggedoutAction from '../useLoggedoutAction';
import { redirectToLogin } from '../../utils';

const useLoggedinAction = (
  toggle: () => void,
  action: string,
  currentValue: boolean = false,
  skip?: boolean
) => {
  const { authenticated = false } = useServerData();

  const loggedinToggle = () => {
    if (!authenticated) {
      redirectToLogin(action);
    } else {
      toggle();
    }
  };

  return useLoggedoutAction(loggedinToggle, action, currentValue, skip);
};

export default useLoggedinAction;
